<template>
  <v-row
    v-if="voice_open"
  >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-container
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-container>
      </template>
      <v-card>
        <v-toolbar
          :color="site_color"
          dark
        >
          <h2 class="font-weight-bold">
            {{ voice_name }}
          </h2>
        </v-toolbar>
        <div
          class="ma-3 pa-3"
        >
          <div
            class="voice-markdown"
            v-html="compiledMarkdown"
          />
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div
            class="text-center"
          >
            <v-btn
              :color="site_color"
              class="mx-1 my-3"
              text
              rounded
              large
              @click="close()"
            >
              Close
            </v-btn>
            <v-btn
              :color="site_color"
              class="mx-1 my-3"
              rounded
              large
              @click="play()"
            >
              <v-icon
                left
              >
                mdi-account-voice
              </v-icon>
              Play Voice
            </v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { marked } from 'marked'
  export default {
    name: 'VoiceModal',
    props: {
      title: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
      card_title: {
        type: String,
        default: '',
      },
    },
    $_veeValidate: {
      validator: 'new',
    },

    data: () => ({
      dialog: false,
      buttonLoading: false,
      voice_open: false,
      voice_name: '',
      voice_markdown: '',
      site_color: '',
      audio: new Audio(),
      isPlay: false,
    }),
    computed: {
      compiledMarkdown: function () {
        return marked(this.voice_markdown)
      },
    },
    created () {
      this.site_color = this.$store.state.site_color
      this.voice_open = this.$store.state.voice_open
      this.voice_name = this.$store.state.voice_name
      this.voice_markdown = this.$store.state.voice_markdown
      this.audio.src = this.$store.state.voice_url
    },
    mounted () {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_SITE_COLOR') {
          this.site_color = state.site_color
        }
      })
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_VOICE_OPEN') {
          this.voice_open = state.voice_open
        }
      })
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_VOICE_NAME') {
          this.voice_name = state.voice_name
        }
      })
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_VOICE_MARKDOWN') {
          this.voice_markdown = state.voice_markdown
        }
      })
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_VOICE_URL') {
          this.audio.src = state.voice_url
          this.audio.load()
        }
      })
    },
    methods: {
      open () {
        this.dialog = true
      },
      close () {
        this.dialog = false
        this.audio.pause()
        this.isPlay = false
      },
      play: function () {
        this.audio.play()
        this.isPlay = true
      },
      stop: function () {
        this.audio.pause()
        this.isPlay = false
      },
    },
  }
</script>
<style>
  .voice-markdown{
    color:#444;
    line-height:2.0;
  }
</style>
